export const fnColorStatus = (id) => {
  switch (+id) {
    case 1: //open
      return {
        color: '#3268c4',
        bg: '#a8cfff'
      }
    case 3: //reject
      return {
        color: '#ef5f5e',
        bg: '#ffe5e5'
      }
    case 2: //approve
      return {
        color: '#3d8c4e',
        bg: '#e2fbe8'
      }
    case 4: //wait
      return {
        color: '#ddac29',
        bg: '#fef5e2'
      }
    case 5: //editting
      return {
        color: '#550162',
        bg: '#fac0ff'
      }
    case 6: //cancel
      return {
        color: '#ffff',
        bg: '#b2b2b2'
      }

    default: //default
      return {
        color: '#1e1e1e',
        bg: '#bebebe'
      }
  }
}
